import { EQUIPMENTS_PICKER_STATE_TYPE } from '@store/machines/equipmentsPicker';

export function isMassEditing(state: EQUIPMENTS_PICKER_STATE_TYPE) {
  // Don't show buttons when we open from manual add.
  return (
    (state.matches('picking') || state.matches('launched')) &&
    state.context.lastAction !== 'LAUNCH'
  );
}
